<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />

    <!-- <b-modal v-model="mostrar" title="Nuevo Puesto" cancel-title="Cancelar" ok-title="Generar" @ok="nuevoPuesto()" >
       <b-form-select v-model="tipo" :options="tipoTrabajo"></b-form-select> 
    </b-modal> -->
    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">  5. EXPERIENCIA LABORAL DEL DECLARANTE </h4>
      </b-col>
      <b-col md="12">
        <br />
        <p>
          <b>*Incorporar máximo dos empleo anteriores</b >
        </p>
      </b-col>
    </b-row>

    <!-- <b-row v-if="laboral.ninguno">
      <b-col md="12">
        <p>No cuenta con experiencia laboral</p>
      </b-col>
    </b-row>
     -->
    <b-row v-for="(elemento, index) in publico" :key="index" >
         <br />
      <b-col md="12">
        <div class="customHr">.</div>
      </b-col>

       <b-col md="8">
        <h4>PÚBLICO</h4>
      </b-col>
      <b-col md="2">
      </b-col>
      <b-col md="2">
         <b-button variant="success"  @click="editarPuesto(elemento, 'PÚBLICO')" :disabled="enviando">Editar</b-button>
          <b-button variant="danger" class="pull-right" @click="eliminaPuestoPublico(elemento._id, index)" :disabled="enviando">Eliminar</b-button>
      </b-col>

      
      

      <b-col md="4">
        <b-form-group label="País de la institución: ">
           <b-form-input
            disabled
            v-model="elemento.ubicacion"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Nivel u orden de Gobierno: ">
          <b-form-input
           disabled        
            v-model="elemento.nivelOrdenGobierno"
            class="mb-3"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Ámbito Público: ">
     <b-form-input
           disabled           
            
            v-model="elemento.ambitoPublico"
            ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group>
          <label>Institución/Empresa/Nombre, denominación o razón social:</label>
          <b-form-input
             disabled           
            v-model="elemento.nombreEntePublico"
           
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >Unidad administrativa/Área:</label>
          <b-form-input
           disabled
           
            v-model="elemento.areaAdscripcion"
            
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="puesto">Puesto o cargo desempeñado:</label>
          <b-form-input
           disabled
           
            v-model="elemento.empleoCargoComision"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label for="funcion">Función principal:</label>
          <b-form-input
            disabled           
            v-model="elemento.funcionPrincipal"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <label >Ingreso</label>
        <datetime
          disabled
          :input-class="'form-control input'"
          v-model="elemento.fechaIngreso"
          type="date"
          
          />
      </b-col>
      <b-col md="3">
        <label >Egreso</label>
        <datetime
          disabled
          :input-class="'form-control input'"
          v-model="elemento.fechaEgreso"
          type="date"
          
          />
      </b-col>
      <br />
      <!-- <b-col md="12">
        <b-row style="text-align: center">
         
          <b-col>
            <b-button
              v-if="status !== 'Concluida'"
              variant="danger"
              size="sm"
              @click="eliminaPuestoPublico(elemento._id, index)"
              >Eliminar Puesto</b-button>
          </b-col>
      
          <br />
        </b-row>
      </b-col> -->
         <br />
    </b-row>
    <br />
    <b-row v-for="(elemento, index) in privado"  :key="`A-${index}`"  >
 
      <br />
      <b-col md="12">
        <div class="customHr">.</div>
      </b-col>
   
       <b-col md="8">
        <h4>PRIVADO</h4>
      </b-col>
         <b-col md="2">
      </b-col>
      <b-col md="2">
         <b-button variant="success"  @click="editarPuesto(elemento, 'PRIVADO')" :disabled="enviando">Editar</b-button>
          <b-button variant="danger" class="pull-right" @click="eliminaPuestoPrivado(elemento._id, index)" :disabled="enviando">Eliminar</b-button>
      </b-col>


      <b-col md="6">
        <b-form-group label="Sector Privado: ">
          <b-form-input
            disabled
            v-model="elemento.sector.clave"
            class="mb-3"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="País de la institución: ">
           <b-form-input
           disabled
            class="mb-3"
            v-model="elemento.ubicacion"
           
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="8">
        <b-form-group>
          <label >Institución/Empresa/Nombre, denominación o razón social:</label
          >
          <b-form-input
           disabled
            
            v-model="elemento.nombreEmpresaSociedadAsociacion"
            
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label >RFC:</label>
          <b-form-input
           disabled
            
            v-model="elemento.rfc"
   

          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >Área:</label>
          <b-form-input
           disabled
            
            v-model="elemento.area"

          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >Puesto o cargo desempeñado:</label>
          <b-form-input
           disabled
            v-model="elemento.puesto"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <label >Ingreso</label>
        <datetime
          disabled
          :input-class="'form-control input'"
          v-model="elemento.fechaIngreso"
          type="date"
          
          />
      </b-col>
      <b-col md="3">
        <label >Egreso</label>
        <datetime
          disabled
          :input-class="'form-control input'"
          v-model="elemento.fechaEgreso"
          type="date"
          
          />
      </b-col>


      

         
    </b-row>
  <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrarForm = true">Agregar Puesto</b-button >
      </b-col>
    </b-row>
    <b-row>
      
      <b-col md="12">
        <b-form-group>
          <label for="funcion">ACLARACIONES / OBSERVACIONES:</label>
          <b-form-input
           disabled
           
            v-model="laboral.aclaracionesObservaciones"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

    </b-row>
 
      <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(4)" :disabled="enviando">Anterior</b-button>
        <b-button class="pull-right" variant="primary"  @click="actualizarAclaraciones()" :disabled="enviando">Siguiente</b-button>
      </b-col>
    </b-row>

    <form-puesto
      v-if="mostrarForm"
      :mostrar="mostrarForm"
      :puesto="puestoEditar"
      :tipoPuesto="tipoPuesto"
      @cancelar="mostrarForm=false, puestoEditar=null, tipoPuesto=null"
      @publicoAgregado="publicoAgregado"
      @publicoModificado="publicoModificado"
      @privadoAgregado="privadoAgregado"
      @privadoModificado="privadoModificado"
    />

  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import FormPuesto from './formPuesto.vue';

export default {
  name:'laboral',
  props: ["laboral", "status"],
  components: { Datetime,Loader,    FormPuesto  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    publico(){
      let lista = []
      if(this.laboral.experiencia.sectorPublico.length>0){
        this.laboral.experiencia.sectorPublico.forEach(pub=>{
          let obj = {
            _id:pub._id,
            ubicacion: pub.ubicacion,
            nivelOrdenGobierno: pub.nivelOrdenGobierno,
            ambitoPublico: pub.ambitoPublico,
            nombreEntePublico: pub.nombreEntePublico,
            areaAdscripcion: pub.areaAdscripcion,
            empleoCargoComision: pub.empleoCargoComision,
            funcionPrincipal: pub.funcionPrincipal,
            fechaIngreso: pub.fechaIngreso,
            fechaEgreso: pub.fechaEgreso
          }
          lista.push(obj)
        })
      }
      return lista;
    },
    privado(){
      let lista = []
      if(this.laboral.experiencia.sectorPrivado.length>0){
        this.laboral.experiencia.sectorPrivado.forEach(priv=>{

          let obj = {
            _id:priv._id,
            sector:{
              clave:priv.sector.clave,
              valor:priv.sector.valor
            },
            ubicacion: priv.ubicacion,
            nombreEmpresaSociedadAsociacion: priv.nombreEmpresaSociedadAsociacion,
            area: priv.area,
            rfc: priv.rfc,
            puesto: priv.puesto,
      
            fechaIngreso: priv.fechaIngreso,
            fechaEgreso: priv.fechaEgreso
          }
          lista.push(obj)
        })
      }
      return lista;
    }

  },
  data: function() {
    return {
      titulo: this.$route.name,
      mostrarForm:false,
      cambios: false,
      tipoPuesto:null,
      operacion: ["AGREGAR", "MODIFICAR", "SINCAMBIOS", "BAJA"],
      puestoEditar:null,
      enviando: false,
      
     
    };
  },
  methods: {
    publicoAgregado(puesto){
      this.mostrarForm=false
      this.laboral.experiencia.sectorPublico.push(puesto)
    },
    publicoModificado(puesto){
      //console.log(puesto);
      this.mostrarForm=false
      let index = this.laboral.experiencia.sectorPublico.findIndex(x => x._id == puesto._id)
      this.laboral.experiencia.sectorPublico.splice(index,1,puesto)

    },
    privadoAgregado(privado){
      this.mostrarForm=false
      this.laboral.experiencia.sectorPrivado.push(privado)
    },
    privadoModificado(privado){
      this.mostrarForm=false
      let index = this.laboral.experiencia.sectorPrivado.findIndex(x => x._id == privado._id)
      this.laboral.experiencia.sectorPrivado.splice(index,1,privado)
    },
 
    editarPuesto(puesto,tipo){
      this.mostrarForm = true
      this.tipoPuesto = tipo;
      this.puestoEditar = puesto;
    },
    eliminaPuestoPublico(id, index) {
  
        swal({
          text: "¿Está seguro en eliminar el Puesto?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/experienciaLaboral/" +
                  this.$route.params.id +
                  "/sectorPublico/" +
                  this.laboral.experiencia.sectorPublico[index]._id,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
              
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });

                  this.laboral.experiencia.sectorPublico.splice(index, 1);
                  
                  this.contador--;
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo guardar la sección."
                });
                this.enviando = false;
              });
          }
        });
      
        //this.laboral.experiencia.sectorPublico.splice(pos, 1);
        
      
    },

    eliminaPuestoPrivado(id, index) {

      if (id.length > 3) {
        swal({
          text: "¿Está seguro en eliminar el elemento?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
          
            axios
              .delete(
                this.httpURL +
                  "/declaraciones/V2/experienciaLaboral/" +
                  this.$route.params.id +
                  "/sectorPrivado/" +
                  id,

                { headers: { token: this.sessionToken } }
              )
              .then(res => {
           
                if (res.data.ok == true) {
                  this.$notify({
                    group: "foo",
                    type: "success",
                    duration: 2500,
                    speed: 1000,
                    text: res.data.mensaje
                  });

                  this.laboral.experiencia.sectorPrivado.splice(index, 1);
                  this.cambiosPrivado.splice(index, 1);
                  this.contador2--;
                }

                this.enviando = false;
              })
              .catch(error => {
                this.$notify({
                  group: "foo",
                  type: "error",
                  duration: 2500,
                  speed: 1000,
                  text: "No se pudo guardar la sección."
                });
                this.enviando = false;
              });
          }
        });
      } else {
        let pos = this.laboral.experiencia.sectorPrivado.findIndex(function(i) {
          return i._id === id;
        });
        this.laboral.experiencia.sectorPrivado.splice(pos, 1);
        this.cambiosPrivado.splice(index, 1);
        this.contador2--;
      }
    },
   

    actualizarAclaraciones() {
      this.enviando = true;
      let ninguno = this.laboral.experiencia.sectorPublico.length > 0 && this.laboral.experiencia.sectorPrivado.length > 0 ? false : true;
      
      axios.put(this.httpURL + "/declaraciones/V2/experienciaLaboral/" + this.$route.params.id,
         {
            aclaracionesObservaciones: this.laboral.aclaracionesObservaciones,
            ninguno: ninguno
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          this.enviando = false;
          if (res.data.ok) {
          this.$notify({ group: "foo", type: "success", duration: 2500, speed: 1000,text: res.data.mensaje });
          this.verSeccion(6)
          this.cambios = false;
          }
        })
        .catch(error => {
          this.$notify({  group: "foo",type: "error", duration: 2500, speed: 1000, text: "No se pudo guardar la sección."});
          this.enviando = false;
        });
    },

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
  },

  created() {
    
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
